import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ArrowTopRightOnSquareIcon, XMarkIcon } from '@heroicons/react/24/solid';

export function PlayExampleModal({ isOpen, onClose, playUrl, title = 'Try a sample game' }) {
  if (!playUrl) return null;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[70]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-950/82 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto p-3 sm:p-5">
          <div className="flex min-h-full items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-sm overflow-hidden rounded-2xl bg-[#263643] p-3 text-white shadow-2xl shadow-black/45 transition-all sm:p-4">
                <Dialog.Title className="sr-only">{title}</Dialog.Title>
                <button
                  type="button"
                  onClick={onClose}
                  className="absolute right-5 top-5 z-10 inline-flex h-9 w-9 items-center justify-center rounded-lg bg-slate-950/55 text-white/72 transition-colors hover:bg-slate-950/75 hover:text-white"
                  aria-label="Close example game"
                >
                  <XMarkIcon className="h-5 w-5" />
                </button>

                <div className="mx-auto aspect-[9/16] h-[min(72vh,680px)] max-h-[680px] w-full max-w-[382px] overflow-hidden rounded-xl bg-black">
                  <iframe
                    src={playUrl}
                    title={title}
                    className="h-full w-full border-0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
                  />
                </div>

                <a
                  href={playUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl bg-white/[0.04] py-2.5 text-sm font-semibold text-white/78 transition-colors hover:bg-white/[0.07] hover:text-white"
                >
                  <ArrowTopRightOnSquareIcon className="h-4 w-4" />
                  Open game in new tab
                </a>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
